import React from "react";
import CompanyNameHeader from "../Shared/CompanyName/CompanyName";


// Summarized Income Statement
import SummarizedIncomeStatement from "./Assets/SummarizedIncomeStatement";

// Income Statement KPIs
import IncomeStatementKPIs from "./Assets/IncomeStatementKPIs";

// Balance Sheet
import BalanceSheet from "./Assets/BalanceSheet"

// Balance Sheet KPIs
import BalanceSheetKPIs from "./Assets/BalanceSheetKPIs";

//Balance Sheet Bars
import BalanceSheetBars from "../Shared/Charts/Bar/BalanceSheetBars";

import LineRevExpEBIDTA from '../Shared/Charts/Line/LineRevExpEBIDTA';

// Income Statement Ration
import IncomeStatementRatios from "./Assets/IncomeStatementRatios";

// Pie Income Statment Ratios
import PieIncomeStatementRatios from "../Shared/Charts/Pie/PieIncomeStatementRatios";

import BalanceSheetRatios from "./Assets/BalanceSheetRatios";

// Benchmark Financial Metrics
import BenchmarkFinancialMetrics from "./Assets/BenchmarkFinancialMetrics";

// Benchmark Financial Metrics
import ScatterPlot from "../Shared/Charts/ScatterPlot/CompetitorsScatterPlot";



// 2. Financial Performance
const FinancialPerformance = () => {
  return (
    <div>
      {/* 0. company name */}
      <CompanyNameHeader />

      {/* Summarized Income Statement */}
      <SummarizedIncomeStatement />

      {/* Income Statement KPIs */}
      <IncomeStatementKPIs />

      {/* Line Revenue, Expense & EBITDA */}
      <LineRevExpEBIDTA />

      {/* Balance Sheet */}
      <BalanceSheet />

      {/* Balance Sheet KPIS*/}
      <BalanceSheetKPIs />

      {/* Balance Sheet Bars*/}
      <BalanceSheetBars />

      {/* Income Statement Ratios*/}
      <IncomeStatementRatios />

      {/* Pie Income Statement Ratios*/}
      <PieIncomeStatementRatios />

      {/* Balance Sheet Ratios*/}
      <BalanceSheetRatios />

      {/* Benchmark Financial Metrics*/}
      <BenchmarkFinancialMetrics />

      {/* Scatter Plot Competitors*/}
      <ScatterPlot />

    </div>
  );
};

export default FinancialPerformance;
